import { produce } from 'immer';
import { createReducer } from 'typesafe-actions';

import { nextHydrate } from '../actions';
import type { HydrateAction } from '../actions';
import { reconcileState } from '../utils';

import { getSupplySummaryRequestAction } from './actions';
import type { AnalyticsAction, AnalyticsState } from './types';

export const analyticsInitialState: AnalyticsState = {
  supplySummariesByDemandSubAccountUuid: {},
};

export const analyticsReducer = createReducer<
  AnalyticsState,
  AnalyticsAction | HydrateAction
>(analyticsInitialState)
  .handleAction(nextHydrate, (state, { payload }) => ({
    ...state,
    ...reconcileState(payload.analytics, analyticsInitialState),
  }))
  .handleAction(
    getSupplySummaryRequestAction.success,
    (state, { payload: { demandPartnerUuid, response } }) =>
      produce(state, (draftState) => {
        draftState.supplySummariesByDemandSubAccountUuid[demandPartnerUuid] =
          response;
      })
  );
